import { useContext } from "react";
import { AutocompleteInput, Create, DateInput, FormTab, ReferenceInput, required, TabbedForm, TextInput } from "react-admin";
import { AppContext } from "../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../utils/general-profile.enum";

const AcademicPeriodCreate = (props) => {

    const context = useContext(AppContext)

    return (
        <Create {...props}>
            <TabbedForm redirect={'list'}>
                <FormTab label={'Dados Gerais'}>

                    {(context.profile.name === ProfileEnum.SUPERADMIN || context.profile.name === ProfileEnum.GENERAL_PRINCIPAL) && (
                        <ReferenceInput label="Unidade" source="institution_branch" reference="institution-branches" perPage={999}
                            filterToQuery={(text) => ({ "institution_branch.name": text })} sort={{ field: "name", order: "ASC" }} validate={[required()]} fullWidth>
                            <AutocompleteInput
                                source="name"
                                emptyText="Todos"
                                optionText={val => `${val?.institution?.name} - ${val?.name}`}
                                optionValue="id"
                                fullWidth
                            />
                        </ReferenceInput>)}

                    <TextInput source="name" label={'Nome'} fullWidth />
                    <TextInput source="description" label={'Descrição'} fullWidth />
                    <DateInput source="start_at" label={'Data de início'} fullWidth />
                    <DateInput source="end_at" label={'Data de término'} fullWidth />
                </FormTab>
            </TabbedForm>
        </Create>
    )

}

export default AcademicPeriodCreate;